import React from "react"
import {Container} from "./component"

export type StandardContainerProps = {
    children: React.ReactNode
    onMouseEnter: () => void
    onMouseLeave: () => void
    elementRef: React.MutableRefObject<HTMLDivElement | null>
}

const StandardContainer = ({children, onMouseEnter, onMouseLeave, elementRef}: StandardContainerProps) => (
    <Container
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        ref={elementRef}
        data-testid="sec-nav-content"
        id="sec-nav-content"
    >
        {children}
    </Container>
)

export default StandardContainer
